export default {
  name: "ProfileValentinesDay",
  data() {
    return {
      promocode: "SKINLOVE14",
    };
  },
  methods: {
    copyPromocode() {
      navigator.clipboard
        .writeText(this.promocode)
        .then(() => {
          this.$toasted.success("Промокод успішно скопійовано");
        })
        .catch(() => {
          this.$toasted.error("Не вдалося скопіювати промокод");
        });
    },
  },
};
